module.exports = __webpack_public_path__ + "img/icon-4.fw.a5128511.png";